import * as R from 'ramda';
import React from 'react';
import {DateUtils} from "react-day-picker";

import {translate} from 'iss/strings';
import {cancelEvent} from 'iss/service/EvaluationEventService';
import {runBatchOps} from 'iss/utils/batchOps';
import dates from 'iss/utils/dates';
import {ActivationList} from 'iss/widgets/ActivationList';
import {DateRangePicker, RadioGroup, TextArea} from 'iss/widgets/Forms';
import {EventCancelReasonSelector} from 'iss/widgets/Selectors';
import {ModalForm} from 'iss/widgets/batchOps/ModalForm';
import {ConditionalFormSection} from 'iss/widgets/form/ConditionalFormSection';
import {listEventFailuresWithMessage} from 'iss/widgets/batchOps/activation/BatchOpEventFailure';
import validators from 'iss/widgets/form/validation/validators';

const cancelEventsBatchOp = {
  id: "cancelEvents",
  title: "activationOperations.cancelEvents.title",
  progressMessage: "activationOperations.cancelEvents.progressMessage",
  components: {
    settings: ({operationTargets, onCancel, startOperation}) =>
      <ModalForm proceedText={translate('activationOperations.cancelEvents.cancelEvents')} proceedLook="danger"
        initialValues={{cancelMode: 'byDate'}}
        onSubmit={(data) => startOperation(cancelEvents(operationTargets, data))}
        onCancel={onCancel}>
        <RadioGroup id="cancelMode" label="activationOperations.cancelEvents.chooseEventsToCancel" valuePath="cancelMode" options={[
          {value: "byDate", label: translate('activationOperations.cancelEvents.cancelByDate')},
          {value: "all", label: translate('activationOperations.cancelEvents.cancelAll')},
        ]}/>

        <ConditionalFormSection showWhen={R.propEq('byDate', 'cancelMode')}>
          <DateRangePicker id="dateRange" valuePath="dateRange"
            fromLabel="activationOperations.cancelEvents.cancelFrom" validateFrom={validators.required}
            toLabel="activationOperations.cancelEvents.cancelTo" validateTo={validators.required} />
        </ConditionalFormSection>

        <EventCancelReasonSelector label="eventEditor.cancellingReason" valuePath="cancelInfo.reason" validate={validators.chooseOne} id="cancellingReason" />
        <TextArea label="eventEditor.cancellingReasonDescription" valuePath="cancelInfo.description" />

        <ActivationList activations={operationTargets} compact extraColumns={[
            {
              header: translate('activationOperations.cancelEvents.unFinishedEventDates'),
              accessor: (target) => {
                return getCancelableEvents(target).map(formatEventDate).join(", ");
              }
            }
          ]}/>
      </ModalForm>,
    success: <p>{translate("activationOperations.cancelEvents.success")}</p>,
    failure: listEventFailuresWithMessage("activationOperations.cancelEvents.failure"),
  },
};

function cancelEvents(targets, {cancelInfo, cancelMode, dateRange}) {
  const isTargetted = cancelMode == 'all' ? R.always(true) : eventHasDateInRange(dateRange);
  const opsByTarget = targets.map((target) => (
    getCancelableEvents(target).filter(isTargetted).map(event => (
      {
        operation: cancelEvent(event.id, cancelInfo),
        activation: target, event
      }
    ))
  ));
  return runBatchOps(R.unnest(opsByTarget));
}

function eventHasDateInRange(dateRange) {
  return ({plannedDate}) => {
    const date = dates.fromJson(plannedDate);
    return DateUtils.isDayInRange(date, dateRange);
  };
}

function getCancelableEvents(target) {
  return target.events.filter(R.propEq("READY_FOR_EVALUATION", 'state'));
}

const formatEventDate = R.pipe(R.prop('plannedDate'), dates.fromJson, dates.format);

export default cancelEventsBatchOp;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/activation/cancelEvents.jsx